<template>
  <v-form ref="form" v-model="valid" :lazy-validation="true">
    <v-card>
      <div class="message-form__content">
        <v-card-title>
          <span class="headline">{{ titlePrefix }} Item Group</span>
        </v-card-title>

        <v-card-text>
          <v-text-field
            name="itemname"
            label="Name (Shown on Z-report and customer's receipt)"
            v-model="ownItem.name"
            :rules="stringValidation"
          />

          <v-select
            name="vat"
            label="Vat (%)"
            v-model="ownItem.vat"
            :rules="vatValidation"
            :items="['25','12','6','0']"
            :value-comparator="vatComparator"
          />

          <v-select
            name="first state"
            label="First state"
            v-model="ownItem.first_state"
            :items="firstStateList"
          />

          <v-text-field
            name="account number"
            label="Account number"
            v-model="ownItem.account_number"
            type="tel"
            :rules="accountValidation"
          />

          <v-text-field
            name="cost center"
            label="Cost Center"
            v-model="ownItem.cost_center"
            type="tel"
          />

          <v-text-field
            name="auto redeem time"
            label="Automatic redeem time (min)"
            v-model="ownItem.redeem_time"
            type="tel"
            clearable
            :rules="redeemValidation"
            persistent-hint
            hint="Remember to enable 'Automatic redeeming' in operator options"
          />
        </v-card-text>
      </div>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel" color="primary" :disabled="isSaving">Cancel</v-btn>
        <v-btn :disabled="!valid" :loading="isSaving" color="primary" @click="submit">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>

export default {
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      valid: true,
      stringValidation: [v => (v != null && v !== '') || 'Cannot be empty'],
      accountValidation: [v => !v || /^\d*$/.test(v) || 'Only numbers'],
      redeemValidation: [ v =>{
        if(!v || v === null||v===""){
          return true
        }
        if(v < 5){
          return 'Value must be minimum of 5'
        }
        if (Number.isNaN(Number(v))){
          return 'No special characters'
        }
        if(!/^[0-9]+$/.test(v)){
          return 'No special characters'
        }
        return true
      }],
      vatValidation: [
        v => !!v || v === 0 || 'Cannot be empty',
        v => !Number.isNaN(Number(v)) || 'Must be a number',
        v => v >= 0 || 'Can\'t be negative'
      ],
      firstStateList: [{
        text: 'NEW',
        value: 'NEW',
        disabled: false
      }, {
        text: 'READY',
        value: 'READY',
        disabled: true
      }, {
        text: 'PICKUP',
        value: 'PICKUP',
        disabled: true
      }, {
        text: 'REDEEMED',
        value: 'REDEEMED',
        disabled: false
      }],
      ownItem: {}
    }
  },
  computed: {
    isSaving () {
      return this.$store.getters.isLoadingFor(['itemgroups.create', 'itemgroups.update']);
    },
    titlePrefix () {
      return this.ownItem.id ? 'Edit' : 'Add';
    }
  },
  watch: {
    item: {
      immediate: true,
      handler (newVal) {
        this.setOwnItem(newVal);
      }
    }
  },
  methods: {
    setOwnItem (item) {
      if (item) {
        this.ownItem = Object.assign({}, item);
      } else {
        this.ownItem = {};
      }

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    submit () {
      if (!this.$refs.form.validate()) {
        return;
      }
      const item = Object.assign({}, this.ownItem);
      delete item.status;
      delete item.estimated_time;
      this.$emit('submit', item);
    },
    cancel () {
      this.$emit('cancel')
    },
    reset () {
      this.setOwnItem(null);
    },
    vatComparator(a, b) {
      return a == b;
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
